import { render, staticRenderFns } from "./fieldListItem.vue?vue&type=template&id=36b667f2&scoped=true&"
import script from "./fieldListItem.vue?vue&type=script&lang=js&"
export * from "./fieldListItem.vue?vue&type=script&lang=js&"
import style0 from "./fieldListItem.vue?vue&type=style&index=0&id=36b667f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b667f2",
  null
  
)

export default component.exports